import { FC } from 'react';
import { AutoFillIcon } from 'assets/icons';

interface AutoFillFeatureBannerProps {
  onTryAutoFill: () => void;
}

const BANNER_TITLE = 'Save time with AI auto-fill';
const BANNER_DESCRIPTION =
  // eslint-disable-next-line quotes
  "Upload a PDF, photo, or just describe the job - we'll fill in your invoice details automatically.";
const CTA_LABEL = 'Try Auto-fill >';

const AutoFillFeatureBanner: FC<AutoFillFeatureBannerProps> = ({ onTryAutoFill }) => {
  return (
    <div
      className="mb-6 flex flex-row items-center justify-between gap-4 rounded-md border border-borderGray
        bg-[#A4D7FA33] px-4 py-3"
      role="banner"
      aria-label={BANNER_TITLE}>
      <div className="flex min-w-0 flex-1 flex-row items-start gap-3">
        <AutoFillIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-bold text-headingGray">{BANNER_TITLE}</h3>
          <p className="mt-0.5 text-sm font-medium text-primaryText">{BANNER_DESCRIPTION}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={onTryAutoFill}
        className="flex shrink-0 flex-row items-center gap-1 whitespace-nowrap rounded font-semibold
         text-secondary hover:opacity-80"
        tabIndex={0}
        aria-label={`${CTA_LABEL} - opens auto-fill modal`}>
        {CTA_LABEL}
      </button>
    </div>
  );
};

export default AutoFillFeatureBanner;
